export default "__VITE_ASSET__D_e1hLuf__"